<div class="user-settings-scroll">
  <div class="user-settings-page">
    <div class="user-settings-panel">
      <h2>account settings</h2>

      <div class="user-settings-body">
        <p class="intro">manage your profile and settings.</p>

        <div class="settings-placeholder">
          <!-- Tabs hidden for now -->
          <!--
          <div class="settings-tabs">
            <button
              type="button"
              class="tab"
              [class.active]="activeTab === 'profile'"
              (click)="setTab('profile')"
            >
              user profile
            </button>

            <button
              type="button"
              class="tab"
              [class.active]="activeTab === 'settings'"
              (click)="setTab('settings')"
            >
              user settings
            </button>
          </div>
          -->

          <!-- Profile section hidden for now -->
          <div class="settings-section" *ngIf="false">
            <p class="hint">choose an avatar pattern for your profile.</p>

            <div class="profile-grid">
              <button
                type="button"
                class="avatar-option"
                *ngFor="let avatar of profileAvatars"
                [class.selected]="avatar.id === selectedAvatarId"
                (click)="selectAvatar(avatar.id)"
              >
                <div
                  class="avatar-swatch"
                  [ngStyle]="{
                    'background-image': avatar.backgroundImage,
                    'background-color': avatar.backgroundColor
                  }"
                ></div>
              </button>
            </div>
          </div>

          <!-- Settings section shown -->
          <div class="settings-section">
            <div class="form-row toggle-row">
              <label for="autoPinPcn">auto-pin pcn block</label>
              <label class="switch">
                <input
                  id="autoPinPcn"
                  type="checkbox"
                  [(ngModel)]="userSettings.autoPinPcnBlock"
                  name="autoPinPcnBlock"
                />
                <span class="slider"></span>
              </label>
            </div>

            <div class="form-row">
              <label for="defaultStageA">
                for attached to vehicle/handed to driver PCNs, what would you like the
                default state to be?
              </label>
              <select
                id="defaultStageA"
                [(ngModel)]="userSettings.defaultStages.progressionPathA"
                name="defaultStageA"
              >
                <option *ngFor="let stage of getStages('A')" [value]="stage.value">
                  {{ stage.label }}
                </option>
              </select>
            </div>

            <div class="form-row">
              <label for="defaultStageB">
                for CCTV parking PCNs, what would you like the default state to be?
              </label>
              <select
                id="defaultStageB"
                [(ngModel)]="userSettings.defaultStages.progressionPathB"
                name="defaultStageB"
              >
                <option *ngFor="let stage of getStages('B')" [value]="stage.value">
                  {{ stage.label }}
                </option>
              </select>
            </div>

            <div class="form-row">
              <label for="defaultStageC">
                for VDA PCNs, what would you like the default state to be?
              </label>
              <select
                id="defaultStageC"
                [(ngModel)]="userSettings.defaultStages.progressionPathC"
                name="defaultStageC"
              >
                <option *ngFor="let stage of getStages('C')" [value]="stage.value">
                  {{ stage.label }}
                </option>
              </select>
            </div>

            <div class="form-row">
              <label for="defaultStageD">
                for bus lane PCNs (outside London), what would you like the default
                state to be?
              </label>
              <select
                id="defaultStageD"
                [(ngModel)]="userSettings.defaultStages.progressionPathD"
                name="defaultStageD"
              >
                <option *ngFor="let stage of getStages('D')" [value]="stage.value">
                  {{ stage.label }}
                </option>
              </select>
            </div>

            <div class="form-row">
              <label for="defaultStageE">
                for bus lane PCNs (inside London), what would you like the default state
                to be?
              </label>
              <select
                id="defaultStageE"
                [(ngModel)]="userSettings.defaultStages.progressionPathE"
                name="defaultStageE"
              >
                <option *ngFor="let stage of getStages('E')" [value]="stage.value">
                  {{ stage.label }}
                </option>
              </select>
            </div>

            <div class="form-row">
              <label for="defaultStageF">
                for moving traffic contravention PCNs, what would you like the default
                state to be?
              </label>
              <select
                id="defaultStageF"
                [(ngModel)]="userSettings.defaultStages.progressionPathF"
                name="defaultStageF"
              >
                <option *ngFor="let stage of getStages('F')" [value]="stage.value">
                  {{ stage.label }}
                </option>
              </select>
            </div>

            <div class="form-row">
              <label for="defaultStageG">
                for Clean Air Zone/road user charge PCNs, what would you like the
                default state to be?
              </label>
              <select
                id="defaultStageG"
                [(ngModel)]="userSettings.defaultStages.progressionPathG"
                name="defaultStageG"
              >
                <option *ngFor="let stage of getStages('G')" [value]="stage.value">
                  {{ stage.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="user-settings-actions">
        <div class="actions-row">
          <button class="app-submit primary" (click)="saveSettings()" [disabled]="isSaving">
            {{ isSaving ? 'saving…' : 'save changes' }}
          </button>
        </div>

        <div class="actions-message">
          <span style="color:darkgreen;" class="save-status success" *ngIf="saveSucceeded">settings were updated!</span>
          <span class="save-status error" *ngIf="saveError">{{ saveError }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
